// let baseUrl = 'https://api.eyelovechina.com/pc/v1/';
let baseUrl = 'http://www.eyelovechina.com/api/pc/v1/';
export default baseUrl;



// WEBPACK FOOTER //
// ./src/config/index.js